module.exports = __webpack_public_path__ + "static/media/long-11.12441d01.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/long/long-11.png
// module id = 2135
// module chunks = 0